import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Row } from 'antd'

import {
  ACHDetails,
  CreditCardDetails,
  PaymentMethod,
} from 'core/application/adminDashboard/companySettings/subscription/subscriptionDetails'

import ACH from './ach/index'
//
import CreditCard from './creditCard'

interface PaymentInformationProps {
  paymentMethod: PaymentMethod
  paymentDetails: CreditCardDetails | ACHDetails
  onSave: () => void
}

const PaymentInformation: React.FC<PaymentInformationProps> = ({ paymentMethod, paymentDetails, onSave }) => {
  const { t: translate } = useTranslation()
  return (
    <Row>
      <Col span={24}>
        <h6>{translate('admin-dashboard.company-settings.subscription.payment-information')}</h6>
        {paymentMethod === PaymentMethod.CreditCard ? (
          <CreditCard {...(paymentDetails as CreditCardDetails)} onSave={onSave} />
        ) : (
          <ACH {...(paymentDetails as ACHDetails)} onDataSave={onSave} />
        )}
      </Col>
    </Row>
  )
}

export default PaymentInformation
